import { noteConstant } from '../constants';

export function note (state = {}, action) {
    switch (action.type) {
      case noteConstant.NOTE_LIST_REQUEST:
        return { 
          loading:action.res
         };
      case noteConstant.NOTE_LIST_SUCCESS:
        return {
          notes: action.res,
          loading:false,
          deleteNote:false
        };
      case noteConstant.NOTE_LIST_FAILURE:
        return {
          error: action.error,
          loading:false
        };
        case noteConstant.NOTE_LIST_SHOW:
        return {
           ...state ,noteView: action.data,
           loading:false
        };
        case noteConstant.NOTES_DELETE_SUCCESS:
          return {
            ...state,
            deleteNote:true
          }
      default:
        return state
    }
  }


// WEBPACK FOOTER //
// ./src/store/reducers/note.reducer.js